import { ContentEditsCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/ContentEditsCreateGraphic";
import { StylesAndJsCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/StylesAndJsCreateGraphic";
import { ThemeCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/ThemeCreateGraphic";
import { TemplateCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/TemplateCreateGraphic";
import { AmountOffProductsCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/AmountOffProductsCreateGraphic";
import { FreeGiftCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/FreeGiftCreateGraphic";
import { BuyXGetYCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/BuyXGetYCreateGraphic";
import { FreeShippingCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/FreeShippingCreateGraphic";
import { AmountOffOrderCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/AmountOffOrderCreateGraphic";
import { PriceChangeCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/PriceChangeCreateGraphic";
import { TextOnlyCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/TextOnlyCheckoutCreateGraphic";
import { TrustBadgeCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/TrustBadgeCheckoutCreateGraphic";
import { CallOutCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/CallOutCheckoutCreateGraphic";
import { CountdownTimerCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/CountdownTimerCheckoutCreateGraphic";
import { ShippingBarCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/ShippingBarCheckoutCreateGraphic";
import { RedirectsCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/RedirectsCreateGraphic";
import { CheckoutUpsellCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/CheckoutUpsellCreateGraphic";
import { VolumeDiscountCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/VolumeDiscountCreateGraphic";
import { ShippingRatesCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/ShippingRatesCreateGraphic";
import { StaticImageCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/StaticImageCheckoutCreateGraphic";
import { BrandLogoCheckoutCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/BrandLogoCheckoutCreateGraphic";
import { PostPurchaseFunnelsCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/PostPurchaseFunnelsCreateGraphic";
import { PostPurchaseUpsellCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/PostPurchaseUpsellCreateGraphic";
import { OnsiteUpsellCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/OnsiteUpsellCreateGraphic";
import { OnsiteBundleUpsellCreateGraphic } from "@src/components/Dialogs/CreateExperienceDialog/graphics/OnsiteBundleUpsellCreateGraphic";
import React from "react";
import { GraphicKind } from "@src/components/Dialogs/CreateExperienceDialog/types";

export const ExperienceCardGraphic = ({ kind }: { kind: GraphicKind }) => {
  switch (kind) {
    case "contentEdits":
      return (
        <ContentEditsCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "stylesAndJavaScript":
      return (
        <StylesAndJsCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "theme":
      return <ThemeCreateGraphic sx={{ width: "100%", height: "120px" }} />;
    case "template":
      return <TemplateCreateGraphic sx={{ width: "100%", height: "120px" }} />;
    case "productDiscount":
      return (
        <AmountOffProductsCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "freeGift":
      return <FreeGiftCreateGraphic sx={{ width: "100%", height: "120px" }} />;
    case "buyXGetY":
      return <BuyXGetYCreateGraphic sx={{ width: "100%", height: "120px" }} />;
    case "freeShipping":
      return (
        <FreeShippingCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "orderDiscount":
      return (
        <AmountOffOrderCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "priceChange":
      return (
        <PriceChangeCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "textOnly":
      return (
        <TextOnlyCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "trustBadge":
      return (
        <TrustBadgeCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "callout":
      return (
        <CallOutCheckoutCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "countdownTimer":
      return (
        <CountdownTimerCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "shippingProgress":
      return (
        <ShippingBarCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "redirects":
      return <RedirectsCreateGraphic sx={{ width: "100%", height: "120px" }} />;
    case "upsell":
      return (
        <CheckoutUpsellCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "volumeDiscount":
      return (
        <VolumeDiscountCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "shippingRates":
      return (
        <ShippingRatesCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "staticImage":
      return (
        <StaticImageCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "brandLogo":
      return (
        <BrandLogoCheckoutCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "postPurchaseFunnel":
      return (
        <PostPurchaseFunnelsCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "postPurchaseUpsell":
      return (
        <PostPurchaseUpsellCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    case "onsiteUpsell":
      return (
        <OnsiteUpsellCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
    case "onsiteBundleUpsell":
      return (
        <OnsiteBundleUpsellCreateGraphic
          sx={{ width: "100%", height: "120px" }}
        />
      );
    default:
      return (
        <ContentEditsCreateGraphic sx={{ width: "100%", height: "120px" }} />
      );
  }
};
